import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { convertToCurrencyFormat } from "../../helpers/Utils";
import { REFUND_PAYMENT_TYPES } from "../../actions";
import StaticLogo from "../../shared/images/common/logo.png";
class RefundReceipt extends PureComponent {
  renderHeader(feeAccount) {
      const { instituteLogo } = this.props;
    return (
      <div style={{ borderBottom: "2px solid gray", paddingBottom: 5 }}>
            <div style={{ position: 'absolute', width: '15%', }}>
              <img
                alt=""
                src={instituteLogo || StaticLogo}
                style={{
                  display: 'block', width: 'auto', height: 'auto', objectFit: 'contain', maxWidth: '100%', maxHeight: 120,
                }} />
            </div>
        <div
          style={{
            fontSize: 25,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {feeAccount.name}
        </div>
        {!!feeAccount.address && (
            <div style={{
              fontSize: 14,
              textAlign: "center",
            }}>{feeAccount.address}</div>
        )}
        {!!feeAccount.gst_number && (
          <div style={{ marginTop: 5, fontSize: 14 }}>
              <span style={{ fontWeight: "bold" }}>GSTIN: </span>
              {feeAccount.gst_number}
            </div>
        )}
      </div>
    );
  }

  renderStudentInfo() {
    const { student, paymentDate } = this.props;
    return (
      <>
        <div
          style={{
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "5px 0px 0px 0px",
          }}
        >
          <div style={{ margin: "5px 0px" }}>
            <span style={{ fontWeight: "bold" }}>Student ID: </span>
            {student.badge_id}
          </div>
          <div>
            <span style={{ fontWeight: "bold" }}>Date: </span>
            {paymentDate}
          </div>
        </div>
        <div style={{ fontSize: 14 }}>
          <span style={{ fontWeight: "bold" }}>Student Name: </span>
          {student.first_name}
        </div>
      </>
    );
  }

  renderTable() {
    const { refundGroup } = this.props;

    const totalAmount = refundGroup && refundGroup.reduce(
      (sum, fee) => sum + Number(fee.amount),
      0
    );
    return (
      <div
        style={{ flex: 1, display: "flex", margin: "20px 0px", fontSize: 14 }}
      >
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 7px;
            border-bottom: 1px solid gray;
          }
          td {
            padding: 7px;
            text-align: center;
          }
        `}
        </style>
        <table
          style={{
            flex: 1,
            borderSpacing: 0,
            borderTop: "1px solid gray",
            borderBottom: "1px solid gray",
          }}
        >
          <thead>
            <tr style={{ borderBottom: "1px solid gray" }}>
              <th>S.NO</th>
              <th style={{ textAlign: "left" }}>Fee Item</th>
              <th style={{ textAlign: "left" }}>Mode</th>
              <th style={{ textAlign: "right" }}>Refund Amount</th>
            </tr>
          </thead>
          <tbody>
            {refundGroup.map((fee, index) => (
              <tr key={fee.fee_due_id}>
                <td>{index + 1}</td>
                <td style={{ textAlign: "left" }}>{fee.name}</td>
                <td style={{ textAlign: "left" }}>
                  {Object.keys(REFUND_PAYMENT_TYPES).find(
                    (type) => REFUND_PAYMENT_TYPES[type] === Number(fee.payment_type)
                  )}
                </td>
                <td style={{ textAlign: "right" }}>
                  {convertToCurrencyFormat(fee.amount)}
                </td>
              </tr>
            ))}
            <tr>
              <td style={{ borderTop: "1px solid gray" }}></td>
              <td
                style={{
                  borderTop: "1px solid gray",
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                Total
              </td>
              <td style={{ borderTop: "1px solid gray" }}></td>
              <td style={{ borderTop: "1px solid gray", textAlign: "right" }}>
                {convertToCurrencyFormat(totalAmount)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderFooter() {
    return (
      <div
        style={{
          flex: 1,
          padding: 15,
          display: "flex",
          justifyContent: "center",
        }}
      >
        This is a computer generated invoice. No signature is required.
      </div>
    );
  }

  render() {
    const { feeAccountID, feeAccounts } = this.props;
    const feeAccount = feeAccounts.find(
        (account) => Number(account.id) === Number(feeAccountID)
    );
      return (
      <div
        style={{
          height: "148mm",
          width: "210mm",
          background: "white",
        }}
      >
        <div style={{ padding: "10mm" }}>
          {feeAccount && this.renderHeader(feeAccount)}

          <div
            style={{
              fontSize: 20,
              fontWeight: "bold",
              margin: "15px 0px 10px 0px",
              textAlign: "center",
            }}
          >
            REFUND FEE RECEIPT
          </div>
                {this.renderStudentInfo()}
                {this.renderTable()}
          <div
            style={{
              flex: 1,
              display: "flex",
            }}
          >
            {this.renderFooter()}
          </div>
        </div>
      </div>
    );
  }
}

RefundReceipt.propTypes = {
  feeGroup: PropTypes.array,
  refundGroup: PropTypes.array,
  student: PropTypes.object,
  paymentDate: PropTypes.string.isRequired,
  feeAccounts: PropTypes.array,
  feeAccountID: PropTypes.number,
};

RefundReceipt.defaultProps = {
    feeGroup: [],
    refundGroup: [],
  student: {},
  feeAccounts: [],
  feeAccountID: null,
};

const mapStateToProps = ({ student, home }) => ({
  student,
  feeAccounts: home.feeAccounts,
});

export default connect(mapStateToProps, {})(RefundReceipt);
